import React from "react";
import DocumentViewer from "../../Common/DocumentViewer/DocumentViewer";

const TermsOfUse: React.FC = () => {
  const docUrl = "/evonext.ai/RegPulse-Terms-of-Use-v2.docx";

  return (
    <>
    <div style={{padding:"60px" }}>
      {/* <h1>Document</h1> */}
      <DocumentViewer docUrl={docUrl} />
    </div>
    </>
  );
};

export default TermsOfUse;